import * as React from 'react';
import store from '@/redux/index';
import { types } from '@/redux/ui/address';
import config from '../../../server/config';
import request from '../../../server/request';
const Toast = require('react-toast-mobile');

export default class PersonalApply extends React.Component<any, any> {
    private isSubmiting: boolean = false; // 是否处于提交中，防止重复点击提交
    public constructor(props: any) {
        super(props);
        this.state = {
            addressInfo: {
                city: {},
                district: {},
                province: {}
            },
            dept: '', // 部门id
            deptName: '', // 部门名称
            deptList: [], // 部门列表
            industryPanelVisible: false, // 行业多选可视化
            industry: [], // 行业列表
            industrySelectResult: [], // 行业索引
            industrySelectResultCopy: [], // 行业索引选择备份
            industryIds: '', // 行业选择id
            industryNames: '', // 行业选择名称
            trueName: '', // 姓名
            company: '', // 公司名称
            companyAddress: '', // 公司详细地址
            duty: '', // 职务
            phone: '', // 固话
            account: '', // 账号
            email: '', // 账号
            mainBusiness: '', // 主营产品
            weChat: '', // 微信
            qq: '' // QQ
        };
    }
    public componentDidMount() {
        // 获取初始化数据
        this.getData();
        // 获取部门列表
        this.getDeptList();
        (document as any).documentElement.addEventListener("focusout",function(){
            (document as any).documentElement.scrollTop = 0;
            window.scrollTo(0,0);
         });
    }
    public render() {
        const state = this.state;
        return (
            <div>
                <ul className="personal">
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>账号/移动电话</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入账号/移动电话" disabled value={state.account}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>姓&emsp;&emsp;名</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入姓名" value={state.trueName} onChange={e => this.inputAction('trueName', e)}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>&nbsp;</b>
                            <p>固定电话</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入固定电话" value={state.phone} onChange={e => this.inputAction('phone', e)}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>电子邮箱</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入电子邮箱" value={state.email} onChange={e => this.inputAction('email', e)}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>&nbsp;</b>
                            <p>QQ账号</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入QQ账号" value={state.qq} onChange={e => this.inputAction('qq', e)}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>&nbsp;</b>
                            <p>微&emsp;&emsp;信</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入微信" value={state.weChat} onChange={e => this.inputAction('weChat', e)}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>职&emsp;&emsp;务</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入职务" value={state.duty} onChange={e => this.inputAction('duty', e)}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>部&emsp;&emsp;门</p>
                        </div>
                        <div className="Location picker-btn">
                            <select value={state.dept} onChange={(e: any) => this.pickerSelectAction(e)}>
                                <option value="">请选择</option>
                                {
                                    state.deptList.map((v: any, k: number) => {
                                        return (
                                            <option value={v.id} key={`deptOption${k}`}>{v.name}</option>
                                        )
                                    })
                                }
                            </select>
                            <div>
                                <span>{state.deptName || '请选择'} &nbsp;</span>
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>公司名称</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入公司名称" value={state.company} onChange={e => this.inputAction('company', e)}/>
                    </li>
                    <li onClick={() => this.openAddressPanel()}>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>公司地区</p>
                        </div>
                        <div className="Location">
                            <div>{state.addressInfo.province.name ? (state.addressInfo.province.name + ' ' + state.addressInfo.city.name + ' ' + state.addressInfo.district.name) : '请选择公司地址'} <img src={require('../../../assets/images/choose.png')} className="chooseImg" /></div>
                        </div>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>详细地址</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入详细地址" value={state.companyAddress} onChange={e => this.inputAction('companyAddress', e)}/>
                    </li>
                    <li>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>主营产品</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入主营产品"  value={state.mainBusiness} onChange={e => this.inputAction('mainBusiness', e)}/>
                    </li>
                    <li onClick={() => this.multiOpenAction()}>
                        <div className="personal-tit">
                            <b>*</b>
                            <p>所在行业</p>
                        </div>
                        <div className="Location">
                            <div><span className="select-results">{state.industryNames}</span> <img src={require('../../../assets/images/choose.png')} className="chooseImg" /></div>
                        </div>
                    </li>
                </ul>
                <button className="personal-btn" disabled={!this.validatyForm()} onClick={() => this.submitAction()}>立即认证</button>
                <div className={`ui-multi ${state.industryPanelVisible ? 'active' : null}`}>
                    <div className="ui-multi-select">
                        <div className="ui-multi-head">
                            <span onClick={() => this.multiCancelAction()}>取消</span>
                            <p>请选择(多选)</p>
                            <span onClick={() => this.multiConfirmAction()}>确定</span>
                        </div>
                        <div className="ui-multi-body">
                            {
                                state.industry.map((v: any, k: number) => {
                                    return (
                                        <div className={`ui-multi-item ${state.industrySelectResult[k] ? 'active' : ''}`} onClick={() => this.multiSelectItem(k)} key={`industryItem${k}`}>
                                            <span></span>
                                            {v.name}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    // 获取数据
    private async getData() {
        const r = await request({
            url: `${config.API}member/info`
        });
        if(r.code === 1) {
            const data = r.obj;
            this.setState({
                addressInfo: {
                    city: {
                        code: data.companyAddressCitycode,
                        name: data.companyArea.split(' ')[1]
                    },
                    district: {
                        code: data.companyAddressTowncode,
                        name: data.companyArea.split(' ')[2]
                    },
                    province: {
                        code: data.companyAddressProvincecode,
                        name: data.companyArea.split(' ')[0]
                    }
                },
                dept: data.dept, // 部门id
                deptName: data.deptName,
                trueName: data.trueName, // 姓名
                company: data.company, // 公司名称
                companyAddress: data.companyAddress, // 公司详细地址
                duty: data.duty, // 职务
                phone: data.phone, // 固话
                account: data.mobile, // 账号
                email: data.email, // 账号
                mainBusiness: data.mainBusiness, // 主营产品
                weChat: data.weChat, // 微信
                qq: data.qq, // QQ
                industryIds: data.industry
            });
            store.dispatch({
                type: types.GET_ADDRESS_START,
                data: {
                    pCode: data.companyAddressProvincecode,
                    rating: 1,
                    copy: true
                }
            });
            store.dispatch({
                type: types.GET_ADDRESS_START,
                data: {
                    pCode: data.companyAddressCitycode,
                    rating: 2,
                    copy: true
                }
            });
        }
        this.getIndustry();
    }
    // 获取部门列表
    private async getDeptList() {
        const r = await request({
            url: `${config.API}member/info/dept`
        });
        if(r.code === 1) {
            this.setState({
                deptList: r.obj ? r.obj : []
            });
        }
    }
    /**
     * 选择部门
     * @parma e [输入事件]
     */
    private pickerSelectAction(e: any) {
        if(this.state.dept === e.currentTarget.value) {
            return;
        }
        let deptName = '';
        this.state.deptList.forEach((v: any, k: number) => {
            if(v.id == e.currentTarget.value) {
                deptName = v.name;
            }
        });
        this.setState({dept: e.currentTarget.value, deptName});
    }
    // 打开地址面板
    private openAddressPanel() {
        const that = this;
        store.dispatch({
            type: types.ADDRESS_SHOW,
            showData: {
                init: that.state.addressInfo,
                onConfirm(r: any) {
                    that.setState({addressInfo: r});
                }
            }
        });
    }
    // 获取个人认证所在行业
  private async getIndustry() {
    const r = await request({
      url: `${config.API}member/info/industry`
    });
    if(r.code === 1) {
      const industry = this.state.industryIds ? this.state.industryIds.split(',') : [];
      let industryStr = '';
      let selectResultArr = Array(r.obj.length).fill(false);
      for(let i=0,l=r.obj.length; i<l; i++) {
        for(let j=0,k=industry.length; j<k; j++) {
          if(r.obj[i].id == industry[j]) {
            industryStr += (' ' + r.obj[i].name);
            selectResultArr[i] = true;
            break;
          }
        }
      }
      this.setState({
          industry: r.obj, 
          industryNames: industryStr,
          industrySelectResult: [...selectResultArr],
          industrySelectResultCopy: [...selectResultArr]
    });
    }
  }
  /**
   * 多选
   * @param index 索引
   */
  private multiSelectItem(index: number) {
    // 查看选择多少条
    const selectReady = this.state.industrySelectResult.filter((v: any) => v);
    if(!this.state.industrySelectResult[index] && selectReady.length > 2) {
        return Toast.T.notify('最多只能选择3个行业');
    }
    let r = this.state.industrySelectResult;
    r[index] = !r[index];
    this.setState({industrySelectResult: r});
  }
  // 取消多选
  private multiCancelAction() {
      this.setState({
          industryPanelVisible: false,
          industrySelectResult: [...this.state.industrySelectResultCopy]
      });
  }
  // 确定多选
  private multiConfirmAction() {
    let ids = this.state.industry.reduce((total: string, v: any, k: number) => {
        return total + (this.state.industrySelectResult[k] ? ',' + v.id : '')
    }, '');
    let names = this.state.industry.reduce((total: string, v: any, k: number) => {
        return total + (this.state.industrySelectResult[k] ? ',' + v.name : '')
    }, '');
    this.setState({
        industryPanelVisible: false,
        industrySelectResultCopy: [...this.state.industrySelectResult],
        industryIds: ids.substr('1'),
        industryNames: names.substr('1')
    });
  }
  // 打开行业多选面板
  private multiOpenAction() {
    this.setState({ industryPanelVisible: true }); 
  }
  // 表单验证
  private validatyForm() {
    const state = this.state;

    return state.addressInfo.province.code && 
    state.dept && state.dept !== '' && 
    state.duty && state.duty !== '' && 
    state.industryIds && state.industryIds !== '' && 
    state.trueName && state.trueName !== '' && 
    state.email && state.email !== '' && 
    state.company && state.company !== '' &&  
    state.companyAddress && state.companyAddress !== '' &&
    state.mainBusiness && state.mainBusiness !== '';
  }
  /**
    * 输入处理
    * @param stateName [state对应的状态名称]
    * @parma e [输入事件]
    */
    private inputAction(stateName: string, e: any) {
        let state = {...this.state};
        state[stateName] = e.target.value
        this.setState({...state});
    }
    // 提交表单
    private async submitAction() {
        if(this.isSubmiting) return;
        this.isSubmiting = true;
        const state = this.state;
        const r = await request({
            data: {
                trueName: state.trueName,
                company: state.company,
                companyAddressProvincecode: state.addressInfo.province.code,
                companyAddressCitycode: state.addressInfo.city.code,
                companyAddressTowncode: state.addressInfo.district.code,
                companyAddress: state.companyAddress || '',
                dept: state.dept || '',
                duty: state.duty || '',
                phone: state.phone || '',
                email: state.email || '',
                industry: state.industryIds || '',
                mainBusiness: state.mainBusiness || '',
                qq: state.qq || '',
                weChat: state.weChat || ''
            },
            method: 'post',
            url: `${config.API}member/auth/personal/submit`
        });
        this.isSubmiting = false;
        if(r.code === 1) {
            Toast.T.notify('提交成功');
            setTimeout(() => {
                this.props.history.replace('/');
            }, 2500);
        } else {
            Toast.T.notify(r.message);
        }
    }
}